import React from "react";
import { useState } from "react";
import { certificationLevels, certificationTypes } from "../../../config/api";
import { useDispatch, useSelector } from "react-redux";
import AppBody from "../../components/AppBody";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import {
  getCertification,
  updateCertification,
} from "../../../actions/admin/certification/certification_action";

const EditCertfication = () => {
  const state = useSelector((state) => state.certificationReducer);
  const { id } = useParams();
  const dispatch = useDispatch("");
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(getCertification({ id: id }));
  }, []);

  const [isValue, setIsValue] = useState(false);
  const [certification, setCertification] = useState({
    name: "",
    product_name: "",
    product_link: "",
    level: "",
    certification_type: "",
    exam: "",
    duration: "",
    certification_role: "",
    certification_description: "",
    remark: "",
    cost_doller: "",
    cost_inr: "",
    exam_link: "",
    certification_prerequisites: "",
    recommended_experiance: "",
    is_set: false,
    id: "",
  });

  if (
    !certification.is_set &&
    state.certification &&
    state.certification.certification_type
  ) {
    setCertification({
      name: state.certification.name,
      product_name: state.certification.product_name,
      product_link: state.certification.product_link,
      level: state.certification.level,
      certification_type: state.certification.certification_type,
      exam: state.certification.exam,
      duration: state.certification.duration,
      certification_role: state.certification.certification_role,
      certification_description: state.certification.certification_description,
      remark: state.certification.remark,
      cost_doller: state.certification.cost_doller,
      cost_inr: state.certification.cost_inr,
      exam_link: state.certification.exam_link,
      certification_prerequisites:
        state.certification.certification_prerequisites,
      recommended_experiance: state.certification.recommended_experience,
      is_set: true,
      id: state.certification.id,
    });
    setIsValue(true);
  }
  const formSubmit = () => {
    dispatch(updateCertification(certification));
  };

  if (state.is_done) {
    navigate("/certification/list");
  }

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="">
            <div className="card">
              <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
                <Link
                  to={"/certification/list"}
                  className="d-inline-block mt-2"
                >
                  <i className="ti-arrow-left font-sm text-white"></i>
                </Link>
                <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                  Update Certification
                </h4>
              </div>
              <div className="card-body  p-4 w-100 border-0 ">
                <form enctype="multipart/form-data">
                  <div className="row">
                    <div className="col-lg-6 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Certification Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={certification.name}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              name: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.name ? state.errors.name : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-3 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Select Level
                        </label>
                        <select
                          className="form-control"
                          name={"level"}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              level: e.target.value,
                            })
                          }
                        >
                          <option value={""}> Select Level</option>
                          {certificationLevels.map((li, i) => (
                            <option
                              value={li.value}
                              key={li.value}
                              selected={
                                li.value === certification.level ? true : false
                              }
                            >
                              {li.name}
                            </option>
                          ))}
                        </select>
                        <span className="error-msg">
                          {state.errors.level ? state.errors.level : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-3 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Certification Type
                        </label>
                        <select
                          className="form-control"
                          name={"level"}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              certification_type: e.target.value,
                            })
                          }
                        >
                          <option value={""}> Select Type</option>
                          {certificationTypes.map((li, i) => (
                            <option
                              value={li.value}
                              key={li.value}
                              selected={
                                li.value === certification.certification_type
                                  ? true
                                  : false
                              }
                            >
                              {li.name}
                            </option>
                          ))}
                        </select>
                        <span className="error-msg">
                          {state.errors.certification_type
                            ? state.errors.certification_type
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-3 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Certification Role
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={certification.certification_role}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              certification_role: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.certification_role
                            ? state.errors.certification_role
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-3 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Duration
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={certification.duration}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              duration: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.duration ? state.errors.duration : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-3 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Cost($)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={certification.cost_doller}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              cost_doller: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.cost_doller
                            ? state.errors.cost_doller
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-3 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Cost(INR)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={certification.cost_inr}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              cost_inr: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.cost_inr ? state.errors.cost_inr : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Product Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={certification.product_name}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              product_name: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.product_name
                            ? state.errors.product_name
                            : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-6 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Product Link
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={certification.product_link}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              product_link: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.product_link
                            ? state.errors.product_link
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Exam
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={certification.exam}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              exam: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.exam ? state.errors.exam : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-6 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Exam Link
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={certification.exam_link}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              exam_link: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.exam_link ? state.errors.exam_link : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 mb-12">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Certification Prerequisites
                        </label>
                        <textarea
                          name="description"
                          className="form-control"
                          rows={3}
                          cols={4}
                          value={certification.certification_prerequisites}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              certification_prerequisites: e.target.value,
                            })
                          }
                        >
                          {certification.certification_prerequisites}
                        </textarea>
                        <span className="error-msg">
                          {state.errors.certification_prerequisites
                            ? state.errors.certification_prerequisites
                            : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-6 mb-12">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Recommended Experiance
                        </label>
                        <textarea
                          name="description"
                          className="form-control"
                          rows={3}
                          cols={4}
                          value={certification.recommended_experiance}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              recommended_experiance: e.target.value,
                            })
                          }
                        >
                          {certification.recommended_experiance}
                        </textarea>
                        <span className="error-msg">
                          {state.errors.recommended_experiance
                            ? state.errors.recommended_experiance
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 mb-12">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Certification Description
                        </label>
                        <textarea
                          name="description"
                          className="form-control"
                          rows={3}
                          cols={4}
                          value={certification.certification_description}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              certification_description: e.target.value,
                            })
                          }
                        >
                          {certification.certification_description}
                        </textarea>
                        <span className="error-msg">
                          {state.errors.certification_description
                            ? state.errors.certification_description
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-6 mb-12">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Remark
                        </label>
                        <textarea
                          name="description"
                          className="form-control"
                          rows={3}
                          cols={4}
                          value={certification.remark}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              remark: e.target.value,
                            })
                          }
                        >
                          {certification.remark}
                        </textarea>
                        <span className="error-msg">
                          {state.errors.remark ? state.errors.remark : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12 text-center">
                      <input
                        type="button"
                        name="submit"
                        value="Submit"
                        onClick={() => formSubmit()}
                        className="btn-common px-5"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default EditCertfication;
